/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryResponse,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsPathParams,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachments400,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachments401,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachments500,
} from "../../types/courseRegistrationDocumentController/GetApiV1CourseregistrationDocumentCourseregistrationidAttachments.ts";

function getGetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsUrl(
  courseRegistrationId: GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsPathParams["courseRegistrationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/document/${courseRegistrationId}/attachments` as const,
  };
  return res;
}

/**
 * @description Retorna os grupos de documentos da pessoa vinculada a matricula exigidos pelo curso com status geral, arquivos enviados, dados de aprovação/rejeição e texto OCR, para exibição na aba Documentos do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna os documentos da pessoa vinculada a matricula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/document/:courseRegistrationId/attachments}
 */
export async function getApiV1CourseregistrationDocumentCourseregistrationidAttachments(
  courseRegistrationId: GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments400
      | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments401
      | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsUrl(
      courseRegistrationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
